import find from "lodash.find";
import camelCase from "lodash.camelcase";

function snakeCaseToCamelCaseKeys(obj: Newsletter): Record<string, boolean | string> {
    return Object.keys(obj).reduce((acc: Record<string, boolean | string>, key: string) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const newKey: string = camelCase(key);

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        acc[newKey] = obj[key];

        return acc;
    }, {});
}

function convertToNewsletter(obj: Record<string, unknown>): InternalNewsletter {
    return {
        type: obj["type"] as string,
        subType: obj["subType"] as string,
        group: obj["group"] as string,
        name: obj["name"] as string,
        mainTout: obj["mainTout"] as string,
        subTout: obj["subTout"] as string,
        list: obj["list"] as string,
        listId: obj["listId"] as string,
        title: obj["title"] as string,
        slideoutTout: obj["slideoutTout"] as string,
        subscribed: obj["subscribed"] as boolean
    };
}

export function formatNewsletters(newsletters: Newsletter[] = []): undefined | InternalNewsletter[] {
    if (!newsletters.length) {
        return;
    }

    return newsletters.map(snakeCaseToCamelCaseKeys).map(convertToNewsletter);
}

export function excludeNewslettersById(newsletters: Newsletter[] = [], excludedIds: string[] = []): Newsletter[] {
    return newsletters.filter((newsletter) => !find(excludedIds, (id) => (id === newsletter.listId || id === newsletter.list)));
}

export function getNewslettersById(newsletters: Newsletter[] = [], ids: string[] = []): Newsletter[] {
    return newsletters.filter((newsletter) => find(ids, (id) => (id === newsletter.listId || id === newsletter.list)));
}

export function sortByTitle(newsletters: Newsletter[] = [], order = "ascending"): Newsletter[] {
    return newsletters.sort((a, b): number => {
        const titleA = a.title.toUpperCase();
        const titleB = b.title.toUpperCase();
        const ascending = titleA.localeCompare(titleB);

        return order === "descending" ? (ascending * -1) : ascending;
    });
}

export function getSourceFromQuery(queryObj?: QueryParams): null | string {
    const source = queryObj?.query?.source;

    if (!source) {
        return null;
    }

    const sourceString = decodeURIComponent(source);
    const startOfParams = sourceString.indexOf("?");

    return startOfParams === -1 ? sourceString : sourceString.substr(0, startOfParams);
}
